import { ReactElement } from 'react';

import clsx from 'clsx';

import { RouteToArtistPage } from '@/common/routes/ExternalRoutes';

import styles from './avatar.module.scss';

interface Avatar {
  avatarUrl: string;
  isLicensed: boolean;
  name: string;
  nick: string;
  slug: string;
}
export interface Props {
  author: Avatar;
  size?: 'small' | 'medium' | 'large';
  className?: string;
  imageClassName?: string;
  showName?: boolean;
  onClick?: () => void;
}

const Avatar = ({
  author,
  className,
  imageClassName,
  showName = false,
  size = 'medium',
  onClick,
}: Props): ReactElement => (
  <a
    className={clsx(styles.container, className)}
    data-testid="avatar"
    href={
      RouteToArtistPage({
        nick: author.isLicensed ? author.slug : author.nick,
        licensed: author.isLicensed,
      }).route
    }
    onClick={() => onClick && onClick()}
  >
    <div
      className={clsx(styles.imageWrapper, imageClassName, size && styles[size])}
      data-testid="avatar-image"
    >
      <img
        alt={`${author.name} avatar`}
        className={styles.image}
        loading="lazy"
        src={author.avatarUrl}
      />
    </div>
    {showName && (
      <div className={styles.nameWrapper}>
        <span className={styles.authorName}>{author.name}</span>
      </div>
    )}
  </a>
);

export default Avatar;
